import { attr, belongsTo } from '@ember-data/model';
import { equal, reads } from 'macro-decorators';
import Super from './document-request';

export default class DocumentRequestNote extends Super {
  documentIcon = 'file-text';

  @belongsTo('diagnosis-treatment-plan', { async: false, inverse: null }) diagnosisTreatmentPlan;
  @belongsTo('note-signature-overview', { async: false, inverse: null }) noteSignatureOverview;
  @attr() documentBody;
  @attr() documentDate;
  @attr() documentType;
  @attr('boolean') isSharedGroupNote;
  @attr('boolean') isGenericGroupNote;
  @attr() individualNoteBody;

  @reads('isComplete') hasDocumentPdf;
  @equal('documentType', 'DiagnosisTreatmentPlan') isDiagnosisTreatmentPlan;

  get mixpanelType() {
    switch (this.documentType) {
      case 'DiagnosisTreatmentPlan':
        return 'Diagnosis and Treatment Plan';
      case 'Progress':
        return 'Progress Note';
      default:
        return 'Assessment';
    }
  }
}
